import { HANDLE_PROMPT_ON_CLOSE_FOR_ADD_SECTIONDATA_BY_MODAL, SHOW_TAB_CLOSE_MODAL } from "../constants";

const initialState = {
	confirmTabCloseModal: null,
	isOpenChatWidget: false,
	promptOnCloseForModal : false
};

const modalReducer = (state = initialState, action = null) => {
	switch (action.type) {
		case SHOW_TAB_CLOSE_MODAL:
			return {
				...state,
				confirmTabCloseModal: action.confirmTabCloseModal
			}

		case HANDLE_PROMPT_ON_CLOSE_FOR_ADD_SECTIONDATA_BY_MODAL:
			return {
				...state,
				promptOnCloseForModal: action.data
			}

		default:
			return state;
	}
};

export default modalReducer;